import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";
import { storeModules } from "../../store";
import { IAuthConfigModel } from "../../models/user/auth-config.model";

const UserGetter = namespace(storeModules.User, Getter);
@Component({
    template: require("./template.html")
})
class OmnicasaIconComponent extends Vue {
    @Prop({ required: true })
    name: string;

    @Prop({ required: false })
    size: string;

    @Prop({ required: false })
    customClass: string;

    @Prop({ required: false })
    customStyle: string;

    @UserGetter authConfig: IAuthConfigModel;

    get coUserAuthConfig() {
        return this.authConfig;
    }

    get getCustomClass() {
        if (this.customClass) {
            return `${'omnicasa-icon'} ${this.customClass}`;
        }
        return 'omnicasa-icon';
    }

    get getCustomStyle() {
        let style = '';

        if (this.size) {
            const sizePx = `${this.size}px`;
            style = `width:${sizePx};height:${sizePx};`;
        }

        if (this.customStyle) {
            style = style == '' ? this.customStyle : (style + ';' + this.customStyle);
        }

        return style;
    }

    get getIconUrl() {
        if(this.coUserAuthConfig) {
            return `${this.coUserAuthConfig.ShareResourceUrl}/system-icons/${this.name}`;
        }
        return '';
    }


}

export default OmnicasaIconComponent;
